let ImportSource = /*#__PURE__*/function (ImportSource) {
  ImportSource["AUTOMATIC_INTEGRATION"] = "automatic_import";
  ImportSource["CSV"] = "csv";
  ImportSource["NEW_INTEGRATION"] = "new_integration_import";
  ImportSource["MANUAL_INTEGRATION"] = "manual_import";
  return ImportSource;
}({});

export { ImportSource };
//# sourceMappingURL=Import.js.map
